/** Index of the tab a key moves to (arrows wrap around, Home/End jump); -1 for other keys. */
export function tabIndexAfterKey(key: string, index: number, count: number): number {
  if (key === "ArrowRight") return (index + 1) % count;
  if (key === "ArrowLeft") return (index - 1 + count) % count;
  if (key === "Home") return 0;
  if (key === "End") return count - 1;
  return -1;
}
